{
  "notFound": {
    "seo": {
      "title": "Page Not Found",
      "description": "Oops! This page doesn't exist. Head back to CuriPop and keep exploring fun questions!"
    },
    "title": "Oops! Page Not Found",
    "message": "Looks like this page went on an adventure and got lost!",
    "subMessage": "Let's get you back to exploring.",
    "help": "Or try one of these:",
    "actions": {
      "home": "Go Home",
      "back": "Go Back",
      "explore": "Explore Questions",
      "topics": "Browse Topics"
    }
  },
  "serverError": {
    "title": "Something Went Wrong",
    "message": "We hit a bump in the road! Our team has been notified and is working on it.",
    "code": "Error {code}",
    "actions": {
      "tryAgain": "Try Again",
      "home": "Go Home"
    },
    "supportPrompt": "Problem persists?",
    "supportAction": "Contact Support"
  }
}
